/* ==========================================================================
   Bundle offer - site-wide
   --------------------------------------------------------------------------
   Loaded on EVERY page from layout/theme.liquid. Two jobs:

   1. CLEANUP. The bundle offer discount codes are Buy X Get Y codes, so
      Shopify already stops applying one the moment its bundle (or the offer
      product) leaves the cart - the price is always protected by Shopify.
      This removes any code starting with "BUNDLE-OFFER-" that Shopify reports
      as no longer applicable, so a dead code never lingers on the cart or
      shows a "code not valid" message at checkout. Other codes are untouched.

      The theme's drawer remove and quantity buttons call /cart/change.js and
      fire no event on success (cart:updated only fires on errors), so
      cart-writing requests are observed directly. Responses pass through
      untouched, and this script's own requests are marked and ignored.

   2. QUICK ADD. When a bundle is added with a product card's cart icon (a
      collection grid, search, recommendations), fetch that bundle's upsell
      markup from /products/<handle>?view=bundle-upsell and show it through
      window.BundleUpsell (assets/bundle-upsell.js, loaded on demand).
   ========================================================================== */

(function () {
  'use strict';

  if (window.__bundleOfferCleanupReady) return;
  window.__bundleOfferCleanupReady = true;

  var PREFIX = 'BUNDLE-OFFER-';
  var OWN_HEADER = 'X-Bundle-Offer';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var QUICK_ADD_WINDOW = 15000;
  var busy = false;
  var again = false;
  var timer = null;

  function cartBase() {
    return (window.T4Sroutes && window.T4Sroutes.cart_url) || '/cart';
  }

  function refreshCart() {
    try {
      if (window.T4SThemeSP && T4SThemeSP.Cart && typeof T4SThemeSP.Cart.getToFetch === 'function') {
        T4SThemeSP.Cart.getToFetch();
      }
    } catch (e) {
      /* theme API unavailable - the cart still shows correctly on next load */
    }
  }

  function isOurs(code) {
    return String(code || '').toUpperCase().indexOf(PREFIX) === 0;
  }

  /* =====================================================================
     1. Cleanup
     ===================================================================== */

  function run() {
    // bundle-upsell.js is mid-way through applying a code - check back shortly
    // instead of racing it for the cart's code list.
    if (window.__bundleOfferApplying && Date.now() - window.__bundleOfferApplying < 1500) {
      schedule();
      return;
    }

    if (busy) {
      again = true;
      return;
    }
    busy = true;

    fetch(cartBase() + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        var stale = codes.filter(function (d) {
          return isOurs(d.code) && d.applicable === false;
        });
        if (!stale.length) return null;

        var keep = codes
          .filter(function (d) {
            return stale.indexOf(d) === -1;
          })
          .map(function (d) {
            return String(d.code);
          });

        var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
        headers[OWN_HEADER] = '1';

        return fetch(cartBase() + '/update.js', {
          method: 'POST',
          headers: headers,
          credentials: 'same-origin',
          body: JSON.stringify({ discount: keep.join(',') })
        }).then(function () {
          refreshCart();
        });
      })
      .catch(function () {
        /* try again on the next cart change */
      })
      .then(function () {
        busy = false;
        if (again) {
          again = false;
          schedule();
        }
      });
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(run, 400);
  }

  /* Announce a cart change: schedule the cleanup, and let bundle-upsell.js
     re-sync its selection lock. */
  function cartChanged() {
    schedule();
    try {
      document.dispatchEvent(new CustomEvent('bundle-offer:cart-changed'));
    } catch (e) {
      /* very old browser - the cleanup still runs */
    }
  }

  function urlOf(input) {
    return typeof input === 'string' ? input : (input && input.url) || '';
  }

  function isOwnRequest(init) {
    var h = init && init.headers;
    if (!h) return false;
    if (typeof h.get === 'function') return !!h.get(OWN_HEADER);
    return !!h[OWN_HEADER];
  }

  if (window.fetch && !window.__bundleOfferFetchPatched) {
    window.__bundleOfferFetchPatched = true;
    var nativeFetch = window.fetch;

    window.fetch = function (input, init) {
      var request = nativeFetch.apply(window, arguments);
      try {
        if (CART_WRITE.test(urlOf(input)) && !isOwnRequest(init)) {
          request.then(
            function (res) {
              if (res && res.ok) cartChanged();
            },
            function () {}
          );
        }
      } catch (e) {
        /* never interfere with the original request */
      }
      return request;
    };
  }

  if (window.XMLHttpRequest && !window.__bundleOfferXhrPatched) {
    window.__bundleOfferXhrPatched = true;
    var nativeOpen = XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (CART_WRITE.test(String(url || ''))) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300) cartChanged();
          });
        }
      } catch (e) {
        /* never interfere with the original request */
      }
      return nativeOpen.apply(this, arguments);
    };
  }

  /* =====================================================================
     2. Quick add - show a bundle's upsell outside its product page
     ===================================================================== */

  var pendingQuickAdd = null;
  var markupCache = {};

  /* "/collections/bundles/products/the-kit?x=1" and "/products/the-kit" are the
     same product; reduce every link to one canonical /products/<handle> path. */
  function productPath(href) {
    var match = String(href || '').match(/\/products\/([^\/?#]+)/);
    if (!match) return null;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'products/' + match[1];
  }

  /* Walk up from the clicked button to the nearest element that links to
     exactly one product - that element is the product card. The theme's
     nearest wrapper around the cart icon does not contain the title link, so
     a fixed selector is not enough; and stopping as soon as a second product
     comes into scope means a neighbouring card's link is never picked up. */
  function productUrlFor(button) {
    var el = button;
    while (el && el !== document.body) {
      var links = el.querySelectorAll ? el.querySelectorAll('a[href*="/products/"]') : [];
      if (links.length) {
        var paths = [];
        for (var i = 0; i < links.length; i++) {
          var path = productPath(links[i].getAttribute('href'));
          if (path && paths.indexOf(path) === -1) paths.push(path);
        }
        return paths.length === 1 ? paths[0] : null;
      }
      el = el.parentElement;
    }
    return null;
  }

  /* Capture phase: runs before the theme's own delegated add-to-cart handler.
     Covers both ways a bundle gets added away from its product page:
       - the cart icon on a product card  -> [data-action-atc]
       - a product form in a custom section (e.g. the home page's
         "Recommended Bundles" panel) -> form[action="/cart/add"] */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var button = target.closest('[data-action-atc]');
      var form = target.closest('form[action*="/cart/add"]');
      var submit = target.closest('button[name="add"], [data-atc-form], input[type="submit"]');
      var trigger = button || (form && submit ? form : null);
      if (!trigger) return;

      // Upsell buttons and anything inside an upsell are handled by bundle-upsell.js.
      if ((button && button.hasAttribute('data-upsell-add')) || target.closest('[data-bundle-upsell]')) {
        pendingQuickAdd = null;
        return;
      }

      /* A product page's own add-to-cart is bundle-upsell.js's job - it reveals
         the upsell already rendered into that page. Only step in when the page
         has no upsell of its own to reveal. */
      if (form && document.querySelector('[data-bundle-upsell]:not([data-upsell-injected])')) {
        pendingQuickAdd = null;
        return;
      }

      var url = productUrlFor(trigger);
      pendingQuickAdd = url ? { url: url, at: Date.now() } : null;
    },
    true
  );

  function loadStylesheet(href) {
    return new Promise(function (resolve) {
      if (!href || document.querySelector('link[href*="bundle-upsell.css"], [data-bundle-upsell-css]')) {
        resolve();
        return;
      }
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = link.onerror = function () {
        resolve();
      };
      document.head.appendChild(link);
      window.setTimeout(resolve, 2500);
    });
  }

  function loadScript(src) {
    return new Promise(function (resolve) {
      if (window.BundleUpsell || !src) {
        resolve();
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.onload = script.onerror = function () {
        resolve();
      };
      document.head.appendChild(script);
    });
  }

  function getDocument(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.text() : '';
      })
      .then(function (html) {
        return html ? new DOMParser().parseFromString(html, 'text/html') : null;
      });
  }

  /* Prefer the lightweight ?view=bundle-upsell template, which marks its
     response with [data-bundle-upsell-view] and returns only the upsell (or
     nothing, for products without one). If that template is missing, Shopify
     renders the store's DEFAULT product template for the URL - not the
     bundle's own template - so the upsell block is absent. Detect that by the
     missing marker and fall back to the product page itself. */
  function fetchMarkup(url) {
    if (!markupCache[url]) {
      markupCache[url] = getDocument(url + '?view=bundle-upsell')
        .then(function (doc) {
          if (doc && doc.querySelector('[data-bundle-upsell-view]')) return doc;
          return getDocument(url);
        })
        .catch(function () {
          delete markupCache[url];
          return null;
        });
    }
    return markupCache[url];
  }

  function showUpsellFor(url) {
    var existing = document.querySelector('[data-bundle-upsell][data-source-url="' + url + '"]');
    if (existing && window.BundleUpsell) {
      window.BundleUpsell.show(existing);
      return;
    }

    fetchMarkup(url).then(function (doc) {
      if (!doc) return;
      var source = doc.querySelector('[data-bundle-upsell]');
      if (!source) return; // this product has no upsell

      var css = doc.querySelector('link[href*="bundle-upsell.css"]');
      var js = doc.querySelector('script[src*="bundle-upsell.js"]');

      Promise.all([
        loadStylesheet(css && css.getAttribute('href')),
        loadScript(js && js.getAttribute('src'))
      ]).then(function () {
        if (!window.BundleUpsell) return;
        if (document.querySelector('[data-bundle-upsell][data-source-url="' + url + '"]')) return;

        var root = document.importNode(source, true);
        root.setAttribute('data-upsell-injected', '');
        root.setAttribute('data-source-url', url);
        document.body.appendChild(root);
        window.BundleUpsell.show(root);
      });
    });
  }

  function onAddSuccess() {
    var pending = pendingQuickAdd;
    pendingQuickAdd = null;
    if (!pending || Date.now() - pending.at > QUICK_ADD_WINDOW) return;
    showUpsellFor(pending.url);
  }

  /* =====================================================================
     Start
     ===================================================================== */

  function init() {
    run();
    if (window.jQuery) {
      window.jQuery(document).on('cart:updated.bundleOfferCleanup', schedule);
      window.jQuery(document).on('add:cart:success.bundleOfferQuickAdd', onAddSuccess);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
